module.exports = __webpack_public_path__ + "img/DE01063.3f27645c.png";